import { openMailto } from '@/utils/openExternalUrl';

export function openReportMailto({
  type,
  title,
  url,
  userId,
}: {
  type: string;
  title: string;
  url: string;
  userId?: number | null;
}): void {
  const subject = encodeURIComponent(`Laporan ${type}: ${title}`);
  const body = encodeURIComponent(
    [
      `Jenis: ${type}`,
      `Nama: ${title}`,
      `URL: ${url}`,
      userId ? `User ID: ${userId}` : null,
    ]
      .filter(Boolean)
      .join('\n')
  );
  openMailto(`mailto:hi@sporto.id?subject=${subject}&body=${body}`);
}
